import PageHead from '../components/page-head/page-head';
import { TitleHeadLicense } from '../mocks/data';
import PanelStatus from '../components/panel-status/panel-status';
import HorizontalTable from '../components/horizontal-table/horizontal-table';
import FilterForPlanAction from '../../vpo/components/planAction/filterForPlanAction/FilterForPlanAction';
import { filterConfig, initialFilter, initialFilterOpen } from '../components/dataForFilters/licenses/filtersDataLicenses';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { isEqual } from 'lodash';
import { getItems } from 'src/modules/spItems/actions';
import { useAppDispatch, useAppSelector } from 'src/hooks/redux';
import { selectItems } from 'src/modules/spItems/selectors';
import { generateLicenses } from '../utils/utils';

import { myTaskActionsListName, MyTaskActionsListFieldsType } from 'src/api/config/myTasksActions.config';
import React from 'react';
import { AdditionalFilters, FilterKey, FilterValue, LicenseFilterKey, SelectionFilterValue } from '../types/typesGos';
import { selectUsers } from 'src/modules/users/selector';
import { addUsers } from 'src/modules/users/actions';
import { selectModelData } from '../store/filterData/selector';
import { transformDataForFilters } from '../utils/utilsGOS';
import { fetchData } from '../store/filterData/actions';
import { selectLastUpdatedId } from '../store/addForms/selector';
import { extractStrapiData, getDataGOS } from '../api/api';

function Licenses() {
  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();
  const [currentFilters, setCurrentFilters] = useState(initialFilter);
  const [prevFilters, setPrevFilters] = useState(initialFilter);
  const [currentPage, setCurrentPage] = useState(1);
  const [filterChangeCounter, setFilterChangeCounter] = useState(0);
  const [localLicenses, setLocalLicenses] = useState<any[]>([]);

  useEffect(() => {
    const licenseId = searchParams.get('licenseCard');
    if (licenseId) {
      getDataGOS('gos-licenses', { 'filters[id][$eq]': licenseId }).then((response) => {
        const data = extractStrapiData(response);
        if (data && data.length > 0) {
          setLocalLicenses(data);
        }
      });
    }
  }, []);
  const itemsPerPage = 75;
  const idUpdateFormLic = useAppSelector((state) => selectLastUpdatedId(state, 'gos-licenses'));

  const locationFilterData = useAppSelector((state: any) => selectModelData(state, 'gos-locations'));
  const typeActivityFilterData = useAppSelector((state: any) => selectModelData(state, 'gos-activities'));
  const typeDocumentFilterData = useAppSelector((state: any) => selectModelData(state, 'gos-document-types'));
  const licenseStatusFilterData = useAppSelector((state: any) => selectModelData(state, 'gos-license-statuses'));
  const actionStatusFilterData = useAppSelector((state: any) => selectModelData(state, 'gos-action-statuses'));
  const licensesData = useAppSelector((state: any) => selectModelData(state, 'gos-licenses'));

  const licensesLoading = useAppSelector((state: any) => state.gosStrapi.filtersData['gos-licenses']?.loading);
  const licensesPagination = useAppSelector((state: any) => state.gosStrapi.filtersData['gos-licenses']?.pagination);

  const hasNextPage = licensesPagination ? licensesPagination.page < licensesPagination.pageCount : false;

  const users: any = useAppSelector(selectUsers);

    useEffect(() => {
    const userEmails = localLicenses.map(license => license.ResponsibleEmail || license.Responsible?.Email).filter(Boolean);
    if (userEmails.length > 0) {
      dispatch(addUsers(userEmails)); 
    }
  }, [localLicenses]);

  //! Получаю локации, тип дейятельности, тип документа, статусы лицензий и действий
  useEffect(() => {
    dispatch(
      fetchData(
        'gos-locations',
        {},
        {
          page: 1,
          pageSize: 100,
        }
      )
    );
    dispatch(
      fetchData(
        'gos-activities',
        {},
        {
          page: 1,
          pageSize: 100,
        }
      )
    );
    dispatch(
      fetchData(
        'gos-document-types',
        {},
        {
          page: 1,
          pageSize: 100,
        }
      )
    );
    dispatch(
      fetchData(
        'gos-license-statuses',
        {},
        {
          page: 1,
          pageSize: 100,
        }
      )
    );
    dispatch(
      fetchData(
        'gos-action-statuses',
        {},
        {
          page: 1,
          pageSize: 1000,
        }
      )
    );
  }, [dispatch]);


  //! трансформация фильтров под страпи
  const locationFilter = React.useMemo(() => transformDataForFilters(locationFilterData), [locationFilterData]);
  const typeActivityFilter = React.useMemo(() => transformDataForFilters(typeActivityFilterData), [typeActivityFilterData]);
  const typeDocumentFilter = React.useMemo(() => transformDataForFilters(typeDocumentFilterData), [typeDocumentFilterData]);
  const licenseStatusFilter = React.useMemo(() => transformDataForFilters(licenseStatusFilterData), [licenseStatusFilterData]);
  const actionStatusFilter = React.useMemo(() => transformDataForFilters(actionStatusFilterData), [actionStatusFilterData]);

  useEffect(() => {
    dispatch(getItems({ listName: myTaskActionsListName, filters: { ImportantHashTag: `#${'Лицензии'}*` } }));
  }, [dispatch]);

  const actions: MyTaskActionsListFieldsType[typeof myTaskActionsListName][] = useAppSelector((state) => selectItems(state, myTaskActionsListName));

  const filterConfigs = {
    location: { items: locationFilter },
    typeActivity: { items: typeActivityFilter },
    typeDocument: { items: typeDocumentFilter },
    statusLicanse: { items: licenseStatusFilter },
    status: { items: actionStatusFilter },
  };

  const filtersMap = {
    location: locationFilter,
    typeActivity: typeActivityFilter,
    typeDocument: typeDocumentFilter,
    statusLicanse: licenseStatusFilter,
    status: actionStatusFilter,
  };

  const handleFiltersChange = useCallback(
    (newFilters: any) => {
      if (!isEqual(currentFilters, newFilters)) {
        console.log('Новые фильтры:', newFilters);
        setLocalLicenses([]);
        setCurrentPage(1);
        setCurrentFilters(newFilters);
      }
    },
    [currentFilters]
  );

  const filterMappings = {
    licenses: {
      location: 'GOSLocation',
      typeActivity: 'TypeActivity',
      typeDocument: 'DocumentType',
    },
  };

  const getFormattedFilters = React.useCallback(() => {
    const additionalFilters: AdditionalFilters = {};

    if (currentFilters.created?.startDate) {
      additionalFilters['StartDateDocument][$gte'] = currentFilters.created.startDate;
    }
    if (currentFilters.created?.endDate) {
      additionalFilters['StartDateDocument][$lte'] = currentFilters.created.endDate;
    }
    if (currentFilters.dataTable?.startDate) {
      additionalFilters['ExpirationDateDocument][$gte'] = currentFilters.dataTable.startDate;
    }
    if (currentFilters.dataTable?.endDate) {
      additionalFilters['ExpirationDateDocument][$lte'] = currentFilters.dataTable.endDate;
    }

    if (currentFilters.responsible && currentFilters.responsible?.selected?.length > 0) {
      additionalFilters.ResponsibleEmail = currentFilters.responsible.selected;
    }

    function isFilterKey(key: string): key is LicenseFilterKey {
      return key in currentFilters;
    }

    function isSelectionFilter(filter: FilterValue): filter is SelectionFilterValue {
      return 'selected' in filter;
    }

    Object.entries(filterMappings.licenses).forEach(([filterKey, mappedKey]) => {
      if (isFilterKey(filterKey) && currentFilters[filterKey] && isSelectionFilter(currentFilters[filterKey]) && currentFilters[filterKey].selectedIds?.length > 0) {
        additionalFilters[mappedKey] = currentFilters[filterKey].selectedIds;
      }
    });

    return {
      mainFilters: { ...additionalFilters },
    };
  }, [currentFilters]);

  //! обновление всего списка при редактировании записи
  useEffect(() => {
    if (idUpdateFormLic) {
      setLocalLicenses([]);
      setCurrentPage(1);
      setFilterChangeCounter((prev) => prev + 1);
    }
  }, [idUpdateFormLic]);

  //! обновление пустой на зполненную
  // useEffect(() => {
  //   if (lastIDFormLic && lastIDFormLic > 0) {
  //     getItemsRequest({
  //       listName: licensesList,
  //       filters: { ID: lastIDFormLic },
  //       anySite: UrlGOS,
  //     }).then((result) => {
  //       if (result) {
  //         const newItem = modifiedItemsState(result.items, licensesList)[0];
  //         setLocalLicenses((prev) => [newItem, ...prev]);
  //       }
  //     });
  //   }
  // }, [lastIDFormLic]);

  // useEffect(() => {
  //   if (idDeleteFormLic) {
  //     setLocalLicenses([]);
  //     setNextPage(undefined);
  //     setGetLicenses(false);
  //   }
  // }, [idDeleteFormLic]);

  //! изменение фильтров
  useEffect(() => {
    const filtersChanged = JSON.stringify(currentFilters) !== JSON.stringify(prevFilters);

    if (filtersChanged) {
      setPrevFilters(currentFilters);
      setCurrentPage(1);
      setFilterChangeCounter((prev) => prev + 1);
      setLocalLicenses([]);
    }
  }, [currentFilters, prevFilters]);

  //! Загрузка данных при изменении фильтров
  useEffect(() => {
    if (filterChangeCounter > 0) {
      const { mainFilters } = getFormattedFilters();
      const isAppend = currentPage > 1;

      dispatch(
        fetchData(
          'gos-licenses',
          mainFilters,
          {
            page: currentPage,
            pageSize: itemsPerPage,
          },
          isAppend
        )
      );
    }
  }, [dispatch, filterChangeCounter, currentPage, getFormattedFilters, itemsPerPage]);

  useEffect(() => {
    setFilterChangeCounter(1);
  }, []);

  //! загрузка следующей страницы
  useEffect(() => {
    if (!licensesLoading && hasNextPage && currentPage > 0) {
      setCurrentPage((prev) => prev + 1);
      setFilterChangeCounter((prev) => prev + 1);
    }
  }, [licensesLoading, hasNextPage, currentPage]);


  useEffect(() => {
    if (licensesData && licensesData.length > 0) {
      const userEmails = licensesData
        .map((license: any) => license.ResponsibleEmail)
        .filter(Boolean);

      if (userEmails.length > 0) {
        dispatch(addUsers(userEmails));
      }
    }
  }, [licensesData, dispatch]);

  useEffect(() => {
    if (licensesData && licensesData.length > 0) {
      const sortedData = [...licensesData].sort((a, b) => b.id - a.id);
      setLocalLicenses(sortedData);
    }
  }, [licensesData]);

  const PanelStatusData = useMemo(() => {
    return users ? generateLicenses(localLicenses, actions, users) : [];
  }, [localLicenses, actions, users]);

  return (
    <div className='flex justify-between w-full h-full'>
      <div className='w-[320px] bg-white'>
        <FilterForPlanAction
          onFiltersChange={handleFiltersChange}
          filterConfigs={filterConfigs}
          filtersMap={filtersMap}
          initialFilters={initialFilter}
          filtersOpen={initialFilterOpen}
          filtersConfig={filterConfig}
          responsibleFil={true}
          heightFilter={'h-[calc(100vh-10px)]'}
        />
      </div>
      <div className='flex-1 min-w-0 m-6'>
        <PageHead isLicenses data={PanelStatusData} isExportLic={true} />

        <PanelStatus
          data={PanelStatusData}
          isLicenses
          filters={{
            statusLicanse: currentFilters.statusLicanse?.selected || currentFilters.statusLicanse?.selectedIds?.map((id) => licenseStatusFilter.find((status) => status.id === id)?.Title),
            status: currentFilters.status?.selected || currentFilters.status?.selectedIds?.map((id) => actionStatusFilter.find((status) => status.id === id)?.Title),
          }}
        />

        <HorizontalTable
          data={PanelStatusData}
          dataHead={TitleHeadLicense}
          isLicenses
          isLoading={licensesLoading || !users}
          hasMorePages={hasNextPage}
          filters={{
            statusLicanse: currentFilters.statusLicanse?.selected || currentFilters.statusLicanse?.selectedIds?.map((id) => licenseStatusFilter.find((status) => status.id === id)?.Title),
            status: currentFilters.status?.selected || currentFilters.status?.selectedIds?.map((id) => actionStatusFilter.find((status) => status.id === id)?.Title),
          }}
        />
      </div>
    </div>
  );
}

export default Licenses;
